// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"IssueMagazineViewer_Wrapper__3sdVG","IssueMagazineViewer":"IssueMagazineViewer_IssueMagazineViewer__dDoXc","fullscreen":"IssueMagazineViewer_fullscreen__XYNa5"};